/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
import React, { Suspense, useEffect } from 'react';
import { useRoutes, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Themeroutes from './routes/Router';
import ThemeSelector from './layouts/theme/ThemeSelector';
import Loader from './layouts/loader/Loader';
import { Navigate } from 'react-router-dom'; // Import Navigate from react-router-dom
import { environment } from './api/api_urls';
import { fetchCurrentAdmin } from './store/api/auth';

const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isLogin = useSelector((state) => state.authdata.isLogin);
  const isAuthChecked = useSelector((state) => state.authdata.isAuthChecked);

  // Function to check if user is logged in
  const isLoggedIn = () => {
    return isLogin; // Return the value of isLogin state
  };

  // Function to render routes based on login status
  const routing = useRoutes(
    Themeroutes.map((route) => {
      // console.log(route.path);
      // If the route is under "/auth" or user is logged in, allow access
      if (
        route.path.startsWith('/reset-password') ||
        route.path.startsWith(`/${environment}/auth`) ||
        !isAuthChecked ||
        isLoggedIn()
      ) {
        return route;
      } else {
        // If user is not logged in, redirect to login page

        return { ...route, element: <Navigate to={`/${environment}/auth/loginformik`} /> };
      }
    }),
  );

  useEffect(() => {
    // Clear legacy auth persistence keys from older builds.
    localStorage.removeItem('user');
    localStorage.removeItem('isLogin');

    const url = new URL(window.location.href);
    const pathSegments = url.pathname.split('/');
    const prodName = pathSegments[1]; // Assuming "prod" is the second segment

    // Valid environment values
    const validEnvironments = ['prod', 'qa', 'future'];

    const isValid = (name) => {
      // Check if it's not null/undefined AND is a valid environment
      return name && name !== 'null' && name !== 'undefined' && validEnvironments.includes(name);
    };

    if (!isValid(prodName)) {
      // If URL path has invalid environment, check stored value
      const storedEnv = localStorage.getItem('environment');
      if (isValid(storedEnv)) {
        // Stored value is valid, use it
        return localStorage.setItem('environment', storedEnv);
      }
      // Neither URL nor stored value is valid, default to prod
      console.warn(`Invalid environment "${prodName}" in URL path. Defaulting to 'prod'.`);
      localStorage.setItem('environment', 'prod');
      // Redirect to correct path with valid environment
      if (prodName && !validEnvironments.includes(prodName)) {
        const newPath = url.pathname.replace(`/${prodName}`, '/prod');
        window.history.replaceState({}, '', newPath + url.search);
      }
      return;
    }

    // prodName is valid, set it
    localStorage.setItem('environment', prodName);
  }, []);

  useEffect(() => {
    dispatch(fetchCurrentAdmin());
  }, [dispatch, location.pathname]);

  const direction = useSelector((state) => state.customizer.isRTL);
  const isMode = useSelector((state) => state.customizer.isDark);

  return (
    <Suspense fallback={<Loader />}>
      <div
        className={`${direction ? 'rtl' : 'ltr'} ${isMode ? 'dark' : ''}`}
        dir={direction ? 'rtl' : 'ltr'}
      >
        <ThemeSelector />
        {routing}
      </div>
    </Suspense>
  );
};

export default App;
